import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    moreIconCard: {
        color: theme.palette.text.primary,
        fontWeight: 400,
    },
    bottleneckIcon: {
        height: "20px",
    },
    pointer: {
        cursor: "pointer",
    },
    cardActionsContainer: {
        display: "flex",
        justifyContent: "flex-end",
        "&.MuiCardActions-root": {
            padding: "0 8px",
        },
    },
    cardContainer: {
        "&.MuiPaper-root": {
            width: "100%",
            height: "100%",
            background: theme.palette.secondary.main,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
        },
    },
    cardContainerBottleneck: {
        "&.MuiPaper-root": {
            width: "100%",
            height: "100%",
            background: theme.palette.corporateBO.bottleneckCardBackground,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
        },
    },
    nameContainer: {
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "1px solid rgba(193, 200, 218, 1)",
    },
    name: {
        "&.MuiTypography-root": {
            textAlign: "left",
            color: theme.palette.text.primary,
            paddingBottom: "5px",
        },
    },
    machineCenterNamesList: {
        display: "flex",
        flexDirection: "column",
        borderBottom: "1px solid rgba(193, 200, 218, 1)",
        padding: `${theme.spacing(1)} 0`,
        minHeight: 100,
    },
    totalHMIs: {
        color: theme.palette.primary.dark,
    },
    totalHMIsAmount: {
        color: theme.palette.primary.darker,
    },
    clusterCodeContainer: {
        marginTop: theme.spacing(1),
    },
    clusterCodeText: {
        fontWeight: "600 !important",
        color: theme.palette.info.main,
    },
    refreshButton: {
        "&.Mui-disabled:disabled": {
            "& > svg": {
                color: theme.palette.primary.dark,
            },
        },
    },
    refreshIcon: {
        color: theme.palette.info.main,
    },
    loadingContainer: {
        padding: "8px",
    },
}));
